export default __webpack_public_path__ + "static/media/money-back.f08f9588.png";